import { render, staticRenderFns } from "./boimport.vue?vue&type=template&id=acda33bc"
import script from "./boimport.vue?vue&type=script&lang=js"
export * from "./boimport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports